import { THREE } from '../stream-particle-system/v3d';

const tmp = new THREE.Vector3();

export const parallelLines = (v1: THREE.Vector3, v2: THREE.Vector3) => {
  return tmp.copy(v1).cross(v2).length() < Number.EPSILON;
};
